export default __webpack_public_path__ + "static/media/dnv-updapt-1.208e33f7.png";